import React from 'react';
import { useHistory } from 'react-router';
import { ContactSupportBase } from 'components/ContactSupport';
import TalentNavbar from 'components/TalentNavbar/TalentNavbar';
import TalentPageLayout from 'components/TalentPageLayout';
import TalentBackButton from 'components/TalentBackButton/TalentBackButton';
import { usePersistedApi } from 'hooks';
import Api from 'api';
import entities from 'reduxStore/entityKeys';
import { UserAccountProps, HYGIENIST_TYPES } from 'utils/types';

const ContactSupport: React.FC = () => {
    const history = useHistory();
    
    const [user] = usePersistedApi({
        apiMethod: Api.getUser,
        entityName: entities.user,
        initialValue: {} as UserAccountProps,
    });

    const hygienist = user?.hygienist;
    const isHygOrAsst = hygienist?.type === HYGIENIST_TYPES.HYGIENIST ||
        hygienist?.type === HYGIENIST_TYPES.ASSISTANT;

    const handleBack = () => {
        const isAdminOrAssociate = 
            hygienist?.type === HYGIENIST_TYPES.ASSOCIATE_DENTIST ||
            hygienist?.type === HYGIENIST_TYPES.FRONT_DESK;

        if (isAdminOrAssociate) {
            history.push('jobPostsList');
        } else {
            // Use React navigation to hygienistHome instead of exitReact
            history.push({ pathname: 'hygienistHome' });
        }
    };

    return (
        <TalentPageLayout
            navbar={(
                <TalentNavbar
                    firstName={hygienist?.firstName || ''}
                    lastName={hygienist?.lastName || ''}
                    photoUrl={hygienist?.photoUrl || undefined}
                    isHygOrAsst={isHygOrAsst}
                    instabookActivated={hygienist?.InstabookActivated === 1}
                    isTestAccount={(hygienist as any)?.isTest === 1}
                    showAddShiftButton={false}
                    showJobBoardButton={false}
                />
            )}
        >
            <TalentBackButton onBack={handleBack} />
            <ContactSupportBase onBack={handleBack} hideNotificationBell hideTopBar />
        </TalentPageLayout>
    );
};

export default ContactSupport;
